import { useState, useEffect } from 'react';
import json2mq from 'json2mq';

var useMedia = function useMedia(query, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var _a = useState(defaultMatches),
      matches = _a[0],
      setMatches = _a[1];

  useEffect(function () {
    var mediaQueryList = window.matchMedia(json2mq(query));

    var listener = function listener() {
      if (mediaQueryList.matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    mediaQueryList.addListener(listener);
    setMatches(mediaQueryList.matches);
    return function () {
      return mediaQueryList.removeListener(listener);
    };
  }, [query]);
  return matches;
};

export default useMedia;
//# sourceMappingURL=useMedia.js.map
